// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1gZ7N","filesListContainer":"PosDisputesFiles_filesListContainer__2LsDw","filesButton":"PosDisputesFiles_filesButton__uF1g2"};